// Null-safe display name for a project's client.
//
// `project.client` is only present when the API eager-loaded the relation
// (resources use whenLoaded), so list/reduced payloads can carry a
// clientType of "company" with no client object. Internal projects have no
// client either. Dereferencing `project.client.name` directly crashes the
// whole page in those cases.
export function getClientName(project, fallback = '') {
  const client = project?.client;
  if (!client) return fallback;

  if (project.clientType === 'contact') {
    const name = [client.firstName, client.lastName].filter(Boolean).join(' ');
    return name || fallback;
  }

  return client.name || client.nameShort || fallback;
}
